import { useEvent } from '~features/events/hooks/useEvent';

const Events = {
  PageViewed: 'Setup Checklist: Viewed',
  ItemClicked: 'Setup Checklist: Item CTA Clicked',
  ItemMarkedAsDone: 'Setup Checklist: Item Completed',
  LearnMoreClicked: 'Setup Checklist: Learn More Clicked',
  AllItemsMarkedAsDone: 'Setup Checklist: All Completed',
  SkipForNow: 'Setup Checklist: Skipped For Now Clicked',
  InviteClicked: 'Setup Checklist: Invite Clicked',
} as const;

type Event = keyof typeof Events;
type EventProperties = Record<string, string | boolean | number>;

type WithItemName = {
  item_name: string;
} & EventProperties;

type WithIsCompleted = {
  is_completed: boolean;
} & EventProperties;


function useTrackSetupChecklistEvent() {
  const { track } = useEvent();

  function trackSetupChecklistEvent(event: 'SkipForNow' | 'AllItemsMarkedAsDone' | 'InviteClicked'): void;
  function trackSetupChecklistEvent(event: 'PageViewed', properties: WithIsCompleted): void;
  function trackSetupChecklistEvent(event: 'ItemClicked', properties: WithIsCompleted & WithItemName): void;
  function trackSetupChecklistEvent(event: 'ItemMarkedAsDone' | 'LearnMoreClicked', properties: WithItemName): void;
  function trackSetupChecklistEvent(event: Event, properties?: EventProperties): void {
    const propertiesWithDefaults = properties ?? {};

    if (event === 'ItemMarkedAsDone') {
      track(Events.ItemMarkedAsDone, { ...propertiesWithDefaults, completion_method: 'marked_manually' });
      return;
    }

    track(Events[event], propertiesWithDefaults);
  }

  return trackSetupChecklistEvent;
}

export default useTrackSetupChecklistEvent;
